import { render, staticRenderFns } from "./highlights-card.vue?vue&type=template&id=3aa39485&"
import script from "./highlights-card.vue?vue&type=script&lang=js&"
export * from "./highlights-card.vue?vue&type=script&lang=js&"
import style0 from "./highlights-card.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports